import { AxiosInstance } from 'axios';
import { Result } from 'services/Result';
import { TrackmanEventsList } from 'types/trackmanEvents';
import i18next from 'i18next';

export class TrackmanEventsService {
  private axiosInstance: AxiosInstance;
  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  getTrackmanEvents = async () => {
    const response = await this.axiosInstance.get<Result<TrackmanEventsList>>(`api/TrackmanEvent`);
    if (response.data && !response.data.isError && response.data.data) {
      return response.data.data;
    }
    throw Error(i18next.t('ErrorWhileFetchingEvents', { ns: 'trackmanEvents' }));
  };
}

export default TrackmanEventsService;
